import { ErrorPage } from '@lune/common/errors'
import { Theme } from '@lune/theme/context'
import { IconButton } from '@mui/material'
import React, { useContext } from 'react'
import { Navigate, RouterProvider, createBrowserRouter } from 'react-router-dom'
import {
  DotsBoxesRoute,
  HomeRoute,
  PatchesDailyRoute,
  PatchesRoute,
  PatchesSeededRoute,
  PipesDailyRoute,
  PipesRoute,
  PipesSeededRoute,
  QueensDailyRoute,
  QueensRoute,
  QueensSeededRoute,
  Resta1DailyRoute,
  Resta1Route,
  Resta1SeededRoute,
  SimonDailyRoute,
  SimonRoute,
  SimonSeededRoute,
  SoCloverRoute,
  CamelRoute,
  SquadRoute,
  SudokuDailyRoute,
  SudokuRoute,
  SudokuSeededRoute,
  TangoDailyRoute,
  TangoRoute,
  TangoSeededRoute,
  Twenty48DailyRoute,
  Twenty48Route,
  Twenty48SeededRoute,
  WendDailyRoute,
  WendRoute,
  WendSeededRoute,
  ZipDailyRoute,
  ZipRoute,
  ZipSeededRoute
} from './paths'

const Home = React.lazy(
  async () => await import('./HomePage').then((m) => ({ default: m.HomePage }))
)

const Queens = React.lazy(
  async () =>
    await import('./queens/page').then((m) => ({ default: m.QueensPage }))
)

const Tango = React.lazy(
  async () =>
    await import('./tango/page').then((m) => ({ default: m.TangoPage }))
)

const Zip = React.lazy(
  async () => await import('./zip/page').then((m) => ({ default: m.ZipPage }))
)

const Wend = React.lazy(
  async () => await import('./wend/page').then((m) => ({ default: m.WendPage }))
)

const Pipes = React.lazy(
  async () =>
    await import('./pipes/page').then((m) => ({ default: m.PipesPage }))
)

const Twenty48 = React.lazy(
  async () =>
    await import('./twenty48/page').then((m) => ({ default: m.Twenty48Page }))
)

const Sudoku = React.lazy(
  async () =>
    await import('./sudoku/page').then((m) => ({ default: m.SudokuPage }))
)

const Patches = React.lazy(
  async () =>
    await import('./patches/page').then((m) => ({ default: m.PatchesPage }))
)

const Resta1 = React.lazy(
  async () =>
    await import('./resta1/page').then((m) => ({ default: m.Resta1Page }))
)

const Simon = React.lazy(
  async () =>
    await import('./simon/page').then((m) => ({ default: m.SimonPage }))
)

const Squad = React.lazy(
  async () =>
    await import('./squad/page').then((m) => ({ default: m.SquadPage }))
)

const DotsBoxes = React.lazy(
  async () =>
    await import('./dotsboxes/page').then((m) => ({ default: m.DotsBoxesPage }))
)

const SoClover = React.lazy(
  async () =>
    await import('./soclover/page').then((m) => ({ default: m.SoCloverPage }))
)

const Camel = React.lazy(
  async () =>
    await import('./camel/page').then((m) => ({ default: m.CamelPage }))
)

const queensElement = (
  <React.Suspense fallback={null}>
    <Queens />
  </React.Suspense>
)
const tangoElement = (
  <React.Suspense fallback={null}>
    <Tango />
  </React.Suspense>
)
const zipElement = (
  <React.Suspense fallback={null}>
    <Zip />
  </React.Suspense>
)
const wendElement = (
  <React.Suspense fallback={null}>
    <Wend />
  </React.Suspense>
)
const pipesElement = (
  <React.Suspense fallback={null}>
    <Pipes />
  </React.Suspense>
)
const twenty48Element = (
  <React.Suspense fallback={null}>
    <Twenty48 />
  </React.Suspense>
)
const sudokuElement = (
  <React.Suspense fallback={null}>
    <Sudoku />
  </React.Suspense>
)
const patchesElement = (
  <React.Suspense fallback={null}>
    <Patches />
  </React.Suspense>
)
const resta1Element = (
  <React.Suspense fallback={null}>
    <Resta1 />
  </React.Suspense>
)
const simonElement = (
  <React.Suspense fallback={null}>
    <Simon />
  </React.Suspense>
)
const squadElement = (
  <React.Suspense fallback={null}>
    <Squad />
  </React.Suspense>
)

const dotsBoxesElement = (
  <React.Suspense fallback={null}>
    <DotsBoxes />
  </React.Suspense>
)

const soCloverElement = (
  <React.Suspense fallback={null}>
    <SoClover />
  </React.Suspense>
)

const camelElement = (
  <React.Suspense fallback={null}>
    <Camel />
  </React.Suspense>
)

const router = createBrowserRouter(
  [
    {
      path: HomeRoute,
      element: (
        <React.Suspense fallback={null}>
          <Home />
        </React.Suspense>
      ),
      errorElement: <ErrorPage />
    },
    { path: QueensRoute, element: queensElement, errorElement: <ErrorPage /> },
    {
      path: QueensSeededRoute,
      element: queensElement,
      errorElement: <ErrorPage />
    },
    {
      path: QueensDailyRoute,
      element: queensElement,
      errorElement: <ErrorPage />
    },
    { path: TangoRoute, element: tangoElement, errorElement: <ErrorPage /> },
    {
      path: TangoSeededRoute,
      element: tangoElement,
      errorElement: <ErrorPage />
    },
    {
      path: TangoDailyRoute,
      element: tangoElement,
      errorElement: <ErrorPage />
    },
    { path: ZipRoute, element: zipElement, errorElement: <ErrorPage /> },
    { path: ZipSeededRoute, element: zipElement, errorElement: <ErrorPage /> },
    { path: ZipDailyRoute, element: zipElement, errorElement: <ErrorPage /> },
    { path: WendRoute, element: wendElement, errorElement: <ErrorPage /> },
    {
      path: WendSeededRoute,
      element: wendElement,
      errorElement: <ErrorPage />
    },
    { path: WendDailyRoute, element: wendElement, errorElement: <ErrorPage /> },
    { path: PipesRoute, element: pipesElement, errorElement: <ErrorPage /> },
    {
      path: PipesSeededRoute,
      element: pipesElement,
      errorElement: <ErrorPage />
    },
    {
      path: PipesDailyRoute,
      element: pipesElement,
      errorElement: <ErrorPage />
    },
    {
      path: Twenty48Route,
      element: twenty48Element,
      errorElement: <ErrorPage />
    },
    {
      path: Twenty48SeededRoute,
      element: twenty48Element,
      errorElement: <ErrorPage />
    },
    {
      path: Twenty48DailyRoute,
      element: twenty48Element,
      errorElement: <ErrorPage />
    },
    { path: SudokuRoute, element: sudokuElement, errorElement: <ErrorPage /> },
    {
      path: SudokuSeededRoute,
      element: sudokuElement,
      errorElement: <ErrorPage />
    },
    {
      path: SudokuDailyRoute,
      element: sudokuElement,
      errorElement: <ErrorPage />
    },
    {
      path: PatchesRoute,
      element: patchesElement,
      errorElement: <ErrorPage />
    },
    {
      path: PatchesSeededRoute,
      element: patchesElement,
      errorElement: <ErrorPage />
    },
    {
      path: PatchesDailyRoute,
      element: patchesElement,
      errorElement: <ErrorPage />
    },
    {
      path: Resta1Route,
      element: resta1Element,
      errorElement: <ErrorPage />
    },
    {
      path: Resta1SeededRoute,
      element: resta1Element,
      errorElement: <ErrorPage />
    },
    {
      path: Resta1DailyRoute,
      element: resta1Element,
      errorElement: <ErrorPage />
    },
    { path: SimonRoute, element: simonElement, errorElement: <ErrorPage /> },
    {
      path: SimonSeededRoute,
      element: simonElement,
      errorElement: <ErrorPage />
    },
    {
      path: SimonDailyRoute,
      element: simonElement,
      errorElement: <ErrorPage />
    },
    { path: SquadRoute, element: squadElement, errorElement: <ErrorPage /> },
    {
      path: DotsBoxesRoute,
      element: dotsBoxesElement,
      errorElement: <ErrorPage />
    },
    {
      path: SoCloverRoute,
      element: soCloverElement,
      errorElement: <ErrorPage />
    },
    {
      path: CamelRoute,
      element: camelElement,
      errorElement: <ErrorPage />
    },
    {
      path: '*',
      element: <Navigate to={HomeRoute} replace />
    }
  ],
  { basename: process.env.PUBLIC_PATH ?? '/' }
)

const ThemeToggle: React.FC = () => {
  const ctx = useContext(Theme)
  return (
    <IconButton
      onClick={ctx.toggle}
      aria-label={ctx.text}
      title={ctx.text}
      sx={{ position: 'fixed', top: 12, right: 12, zIndex: 1300 }}
    >
      {ctx.icon}
    </IconButton>
  )
}

export const App: React.FC = () => (
  <>
    <ThemeToggle />
    <RouterProvider router={router} />
  </>
)
